import { apiGet, apiPatch } from './client.js';

export interface LoyaltySettings {
  loyaltyEnabled: boolean;
  loyaltyEarnRatePerDollar: string;
  loyaltyPointsPerDollarRedemption: string;
  loyaltyMinPointsToRedeem: number;
  loyaltyRepairsEarn: boolean;
  loyaltyRetailEarn: boolean;
  loyaltyPartsEarn: boolean;
  loyaltyShowBalanceOnPortal: boolean;
  loyaltyNotifyOnEarn: boolean;
}

export function getLoyaltySettings() {
  return apiGet<LoyaltySettings>('/api/v1/tenants/loyalty').then((res) => res.data);
}

export function updateLoyaltySettings(body: Partial<LoyaltySettings>) {
  return apiPatch<LoyaltySettings, Partial<LoyaltySettings>>('/api/v1/tenants/loyalty', body).then(
    (res) => res.data,
  );
}
